import React from 'react'
import Map from '../../components/Company/Map'
import Address from '../../components/Company/Address'
import { Helmet } from 'react-helmet-async'
import { Section } from './Contact'

export const Return = () =>
  <>
    <Helmet>
      <title>LFH - Collecting Equipment</title>
    </Helmet>
    <div className="about">
      <h1 className="mar-t-none mar-b">Collecting equipment</h1>
      <Section icon="carry" title="Collect in person" className="mar-t-2">
        <p className="mar-t-none">
          We don't have a shop, so you can't just walk in off the street and pick up a lens.
          Everything has to be booked in advance in the website. But as part of the booking
          process, you'll have the option of selecting a Maidenhead local pickup instead of
          having the equipment delivered to you.
          The pickup address is:
        </p>
        <Address/>
        <p>
          Here's a map to help you find us:
        </p>
        <Map/>
      </Section>
    </div>
  </>

export default Return